import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ArrUtil, Dataset, DatasetRepo, FilterSchema, FSEnumItem, FSLastTimeItem, FSPresetItem } from '@gspwidget/util';
import { FilterComponent } from '@gspwidget/widget-core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'lib-fe-filter-modal',
  templateUrl: './fe-filter-modal.component.html',
  styleUrls: ['./fe-filter-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeFilterModalComponent implements OnInit {
  // @Input() getIntactData: () => Observable<any[]> = defaultGetIntactData
  // @Input() dims: Dimension[]
  @Input('filterSchema') fs = new FilterSchema()
  /** 是否垂直布局，默认 false，水平布局 */
  @Input() vertical = false
  @ViewChild(FilterComponent) filterComp: FilterComponent

  ArrUtil = ArrUtil
  /**
   * 用于获取 items 的数据，未经筛选。
   * 打开此 modal 后，第一次切换到 enum.source==='dataField' 时加载此数据。
   */
  intactData: any[] = null
  /**
   * intactData + valueField + labelField
   * 得到的全部 items，非最终选中的。
   * 选中的存在 fs.enum.itemsFromData。
   */
  allItemsFromData: FSEnumItem[] = []
  /**
   * 用作再次打开编辑器时，展示已选中的 items。
   * 存的是 items，要的是 values，所以需要在初始化时转换一次。
   */
  selectedItemsValue: any[]
  /** 仅用于纯前端暂存当前 item source dataset，显示在页面上 */
  curFsEnumDataset: Dataset
  curEnumItems: any[]
  curItemsDatasetResult: any[]
  listOfOption = ['最近三天', '最近七天', '最近半年'];
  listOfSelectedValue: string[] = [];
  curLang: string

  constructor (
    public datasetRepo: DatasetRepo,
    public cd: ChangeDetectorRef,
    public translate: TranslateService,
  ) { 
    this.curLang = this.translate.currentLang
  }

  ngOnInit () {
    // this.handleChangeEnumSource()
    this.checkNUpdateEnum()
  }
  
  /** 1. type change */
  handleChangeType () {
    this.checkNUpdateEnum()
  }
  /** date */
  handleAddLastTimeItem () {
    ArrUtil.Add(this.fs.date.lastTimeItems, new FSLastTimeItem())
  }
  handleAddEnumItem () {
    ArrUtil.Add(this.fs.enum.itemsManual, new FSEnumItem())    
  }
  /** 2. enum source change */
  handleChangeEnumSource () {
    // if (!this.curFsEnumDataset) {
    //   this.updateDatasetResult()
    // }
    this.checkNUpdateEnum()
  }
  /** 3. enum dataset change */
  handleChangeItemsDataset (flawDataset: Dataset) {
    this.fs.enum.itemsDatasetId = flawDataset.id
    // 呃！“数据集列表”接口中 dims 全为空，所以称为 flaw dataset。
    // 所以再单独请求一次吧。
    this.updateDatasetResult()
  }
  /** 4. dataset enum field change */
  handleItemFieldChange () {
    this.updateDatasetEnumItems()
  }

  handleTableDataChange(newData: any[]) {
    this.setCurEnumItems([...newData]); 
    
    // 确保变更检测
    this.cd.markForCheck();
  }

  /**
   * A.
   * 检查是否需要触发 B。调用时机：
   * 1. 初始化时
   * 2. fs.type 变化时
   * 3. fs.enum.source 变化时
   * 需要调用
   */
  private checkNUpdateEnum () {
    const { type, enum: fsEnum } = this.fs
    //兼容历史数据  add默认属性 初始false
    if(this.fs.enum.firstDefault === undefined){
        this.fs.enum["firstDefault"] = 'false';
    } 
    const { source } = fsEnum
    if (type !== 'enum') return
    if (source === 'manual') {
      this.setCurEnumItems(this.fs.enum.itemsManual)
    } else if (source === 'dataset') {
      if (!this.curItemsDatasetResult) {
        this.updateDatasetResult()
      } else {
        this.updateDatasetEnumItems()
      }
    }
  }
  /**
   * B.
   * 请求、更新 dataset 数据集本体、最终数据等。调用时机：
   * 1. A
   * 2. dataset 切换时
   */
  private updateDatasetResult () {
    if (
      this.fs.enum.source !== 'dataset'
      || !this.fs.enum.itemsDatasetId
    ) return

    this.datasetRepo.getDatasetById(this.fs.enum.itemsDatasetId).subscribe(dataset => {
      this.curFsEnumDataset = dataset
      this.cd.markForCheck()
    })
    this.datasetRepo.getResultByDatasetId(this.fs.enum.itemsDatasetId).subscribe(res => {
      this.curItemsDatasetResult = res
      this.updateDatasetEnumItems()
      this.cd.markForCheck()
    })
  }
  /**
   * C.
   * 用 result 重新得到 dataset items，调用时机：
   * 1. A.
   * 2. B.
   * 3. field 切换时
   */
  private updateDatasetEnumItems () {
    if (!this.curItemsDatasetResult) return
    this.setCurEnumItems(
      this.curItemsDatasetResult.map(item => ({
        label: item[this.fs.enum.itemsLabelField], 
        value: item[this.fs.enum.itemsValueField],
      }))
    )
  }
  private setCurEnumItems (enumItems: FSEnumItem[]) {
    this.curEnumItems = enumItems.map(item => {      
      return {
        ...item,        
        displayLabel: this.resolveLabel(item)
      };
    });
    // this.filterComp.setEnumItems(enumItems)
    this.cd.markForCheck()
  }

  private resolveLabel(item: FSEnumItem): string {
    if (item.label === null || item.label === undefined) {
      return item.value; 
    }    
    if (typeof item.label === 'string') {
      return item.label;
    }     
    if (typeof item.label === 'object') {      
      return item.label[this.curLang] || item.value;
    }
    return item.value;
  }

}
